import { Guard, User } from '.';
import { config } from '../config/config';

export function isYourArmSore(attr) {
  const SORENESS = Array<any>();
  attr.player_whereIsYourArmSoreBackOfElbow && SORENESS.push('Back Of Elbow');
  attr.player_whereIsYourArmSoreOutsideOfForearm && SORENESS.push('Outside Of Forearm');
  attr.player_whereIsYourArmSoreBiceps && SORENESS.push('Biceps');
  attr.player_whereIsYourArmSoreFrontOfForearm && SORENESS.push('Front Of Forearm');
  attr.player_whereIsYourArmSoreBackOfShoulder && SORENESS.push('Back Of Shoulder');
  attr.player_whereIsYourArmSoreFrontOfShoulder && SORENESS.push('Front Of Shoulder');
  attr.player_whereIsYourArmSoreElbowBack && SORENESS.push('Elbow Back');
  attr.player_whereIsYourArmSoreElbowOutside && SORENESS.push('Elbow Outside');
  attr.player_whereIsYourArmSoreElbowBiceps && SORENESS.push('Elbow Biceps');
  attr.player_whereIsYourArmSoreElbowInside && SORENESS.push('Elbow Inside');
  attr.player_whereIsYourArmSoreShoulderBack && SORENESS.push('Shoulder Back');
  attr.player_whereIsYourArmSoreShoulderFront && SORENESS.push('Shoulder Front');
  attr.player_whereIsYourArmSoreOtherCheck && SORENESS.push('Other Check');
  attr.player_whereIsYourArmSoreElbow && SORENESS.push('Elbow');
  attr.player_whereIsYourArmSoreShoulder && SORENESS.push('Shoulder');
  attr.player_whereIsYourArmSoreOther && SORENESS.push('Other');
  attr.player_whereDoesYourArmTypicallyGetSoreOtherCheck && SORENESS.push('Other Check');
  attr.player_whereDoesYourArmTypicallyGetSoreElbow && SORENESS.push('Elbow');
  attr.player_whereDoesYourArmTypicallyGetSoreShoulder && SORENESS.push('Shoulder');
  attr.player_whereDoesYourArmTypicallyGetSoreOther && SORENESS.push('Other');
  if (SORENESS.length) {
    let str = '';
    SORENESS.map((element, index) => {
      if (index === SORENESS.length - 1) {
        return (str += element);
      } else {
        return (str += element + ', ');
      }
    });
    return str;
  } else {
    return undefined;
  }
}

export function secondaryPosition(attr) {
  const POSITION = Array<any>();
  attr.catcherSecondary && POSITION.push('Catcher');
  attr.infielderSecondary && POSITION.push('Infielder');
  attr.outfielderSecondary && POSITION.push('Outfielder');
  attr.pitcherSecondary && POSITION.push('Pitcher');
  if (POSITION.length) {
    let str = '';
    POSITION.map((element, index) => {
      if (index === POSITION.length - 1) {
        return (str += element);
      } else {
        return (str += element + ', ');
      }
    });
    return str;
  } else {
    return undefined;
  }
}

export function deepGet(obj, properties) {
  if (obj === undefined || obj === null) {
    return;
  }
  if (properties.length === 0) {
    return obj;
  }
  var foundSoFar = obj[properties[0]];
  var remainingProperties = properties.slice(1);
  return deepGet(foundSoFar, remainingProperties);
}
export default class Utils {
  private url: string = config.armcareServerUrl;
  private GUARD = new Guard();
  private user = new User();

  public isFutureDate(iDate: string): boolean {
    const now = new Date();
    const fecha = new Date(iDate);

    if (fecha < now) {
      return false;
    } else {
      return true;
    }
  }
  public GetValidationWordsAndNumbers(): RegExp {
    return /^[A-Za-z0-9_-][A-Za-z0-9 _-]*$/;
  }

  public GetValidationNumbers(): RegExp {
    return /^[0-9]+$/;
  }

  public GetValidationInputPattern(): RegExp {
    // eslint-disable-next-line
    return /^[ñA-Za-z _-]{1,}$/;
  }

  public GetValidationBlankPattern(): RegExp {
    // eslint-disable-next-line
    return /^\s*$/;
  }

  public GetValidationWordsWithoutSpecialCharacters(): RegExp {
    return /^[ñA-Za-z ]{1,}$/;
  }

  public GetValidationEmailPattern(): RegExp {
    // eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  }

  public GetValidationPhonePattern(): RegExp {
    // eslint-disable-next-line
    return /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  }

  public GetValidationDatePattern(): RegExp {
    return /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
  }

  public GetValidationHeightPattern(): RegExp {
    return /^\d+\sft(?:\s\d+\sin)?$/
  }

  public GetValidationWeightPattern(): RegExp {
    return /^\d+\slbs$/;
  }

  public CheckDuplicatesInArray(vector: Array<any>): Array<any> {
    const result: any = [];
    const map = new Map();
    for (const item of vector) {
      if (!map.has(item.player.email)) {
        map.set(item.player.email, true);
        result.push(item);
      }
    }
    return result;
  }

  public toBase64(file): Promise<any> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  public async UploadFile(file: File): Promise<any> {
    const credentials = this.user.GetUserCredentials() as any;
    if (credentials.status) {
      const token = credentials.data.access_token;
      const headers = new Headers({
        Authorization: `Bearer ${token}`,
      });
      const body = new FormData();
      body.append('file', file);

      try {
        const response = await fetch(`${this.url}/api/v2/file`, {
          method: 'POST',
          headers,
          body,
        });
        this.GUARD.verifyError(response);
        const data = await response.json();
        if (data.name) {
          return { status: true, data };
        } else {
          return { status: false };
        }
      } catch (e) {
        return { status: false };
      }
    } else {
      return { status: false };
    }
  }

  public Later(delay: number): Promise<any> {
    return new Promise(resolve => setTimeout(resolve, delay));
  }

  public GetRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  public HandleSort(atribute, examtype: Array<any>, sortOptions) {
    const [reverseValue, setReverse, setActiveClass, setTable, table, isWord] = sortOptions;
    const rever = !reverseValue;
    setActiveClass(atribute);

    const sortedData = table.sort((a, b) => {
      let first = deepGet(a, [...examtype]);
      let second = deepGet(b, [...examtype]);
      isWord.test(first);
      if (examtype[0] === 'location') {
        first = isYourArmSore(a.summary);
        second = isYourArmSore(b.summary);
      }
      if (examtype[0] === 'secondaryPosition') {
        first = secondaryPosition(a);
        second = secondaryPosition(b);
      }

      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }

      if (typeof first === 'number' || typeof second === 'number') {
        if (isNaN(first)) {
          return 1;
        }
        if (isNaN(second)) {
          return -1;
        }
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else if (typeof first === 'boolean' || typeof second === 'boolean') {
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else if (first.toLowerCase() > second.toLowerCase()) {
        return rever ? 1 : -1;
      } else if (first.toLowerCase() < second.toLowerCase()) {
        return rever ? -1 : 1;
      }

      return 0;
    });
    setTable(sortedData);
    setReverse(rever);
  }
  //This sort should only be used with numbers or strings that can be parsed to numbers
  public HandleSorted(examtype: Array<any>, sortOptions) {
    const [reverseValue, setTable, table] = sortOptions;
    const rever = reverseValue;
    const sortedData = table?.sort((a, b) => {
      let first = deepGet(a, [...examtype]);
      let second = deepGet(b, [...examtype]);
      const possibleFirst = parseFloat(first);
      const possibleLast = parseFloat(second);
      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }

      if (typeof first === 'number' || typeof second === 'number') {
        if (isNaN(first)) {
          return 1;
        }
        if (isNaN(second)) {
          return -1;
        }
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else if (typeof first === 'boolean' || typeof second === 'boolean') {
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else if (typeof possibleFirst === 'number' || typeof possibleLast === 'number') {
        if (isNaN(possibleFirst)) {
          return 1;
        }
        if (isNaN(possibleLast)) {
          return -1;
        }
        if (possibleFirst > possibleLast) {
          return rever ? 1 : -1;
        }
        if (possibleFirst < possibleLast) {
          return rever ? -1 : 1;
        }
      } else {
        if (first.toLowerCase() > second.toLowerCase()) {
          return rever ? 1 : -1;
        }
        if (first.toLowerCase() < second.toLowerCase()) {
          return rever ? -1 : 1;
        }
      }
      return 0;
    });

    setTable(sortedData);
  }
  // This function works when the backend send TS date, strins, and booleans
  public SortStrings(examType: Array<any>, sortOptions: any) {
    const [reverseValue, setTable, table] = sortOptions;
    const rever = reverseValue;
    const sortedData = table?.sort((a, b) => {
      const first = deepGet(a, [...examType]);
      const second = deepGet(b, [...examType]);
      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }
      if (typeof first === 'boolean' || typeof second === 'boolean') {
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else {
        if (first.toLowerCase() > second.toLowerCase()) {
          return rever ? 1 : -1;
        }
        if (first.toLowerCase() < second.toLowerCase()) {
          return rever ? -1 : 1;
        }
      }
      return 0;
    });
    setTable(sortedData);
  }
  //This function should be used when the backend sends dates like MM/DD/YYYY
  public SortDate(examType: Array<any>, sortOptions: any) {
    const [reverseValue, setTable, table] = sortOptions;
    const rever = reverseValue;
    const sortedData = table?.sort((a, b) => {
      const first = new Date(deepGet(a, [...examType])).getTime() || undefined;
      const second = new Date(deepGet(b, [...examType])).getTime() || undefined;
      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }

      if (first > second) {
        return rever ? 1 : -1;
      }
      if (first < second) {
        return rever ? -1 : 1;
      }

      return 0;
    });
    setTable(sortedData);
  }
  public SortIsoDate(examType: Array<any>, sortOptions: any) {
    const [reverseValue, setTable, table] = sortOptions;
    const rever = reverseValue;
    const convertToTs = date => {
      return new Date(date).getTime() || undefined;
    };
    const sortedData = table?.sort((a, b) => {
      const first = convertToTs(deepGet(a, [...examType]));
      const second = convertToTs(deepGet(b, [...examType]));
      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }

      if (first > second) {
        return rever ? 1 : -1;
      }
      if (first < second) {
        return rever ? -1 : 1;
      }

      return 0;
    });
    setTable(sortedData);
  }

  public SortStringsAndNumbers(examType: Array<any>, sortOptions: any) {
    const [reverseValue, setTable, table] = sortOptions;
    const rever = reverseValue;
    const sortedData = table?.sort((a, b) => {
      const first = deepGet(a, [...examType]);
      const second = deepGet(b, [...examType]);
      if (first === undefined) {
        return 1;
      }
      if (second === undefined) {
        return -1;
      }
      if (typeof first === 'boolean' || typeof second === 'boolean') {
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      } else {
        if (first > second) {
          return rever ? 1 : -1;
        }
        if (first < second) {
          return rever ? -1 : 1;
        }
      }
      return 0;
    });
    setTable(sortedData);
  }
}
